import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPictureInPicture: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPictureInPicture"><Path d="M9.5 17.5H2.5V4.5H19.5V11.5M12.5 14.5H21.5V20.5H12.5V14.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPictureInPicture;
